import { createAction, props } from '@ngrx/store';

export const SetAppId = '[Global] Set appId';

export const setAppId = createAction(SetAppId, props<{ appId: string }>());
